export default {"src":"/_next/static/media/earth.65f47be5.svg","height":24,"width":24};